class EpreuveDTO {

    constructor(epreuveData){
        if(!epreuveData || Object.keys(epreuveData).length === 0)
            return

        const {_id, name, provider} = epreuveData

        this._id = _id
        this.name = name

        this.provider = provider
    }
}

export default EpreuveDTO